var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dynamic-rail-loading-state"},[(_vm.loading)?_c(_setup.TG4Loader,{attrs:{"compact":""}}):_c('p',{staticClass:"state-message"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }